import { useMemo } from "react";
import {
  ROLE_ADMINISTRATOR,
  ROLE_DIGITAL_STORES,
  ROLE_TAP_ADMIN,
} from "../../../config/userRoles";

/**
 * Hook to check PPT authorization permissions.
 * Separates authorization logic from UI components.
 */
export const usePPTAuthorization = () => {
  return useMemo(() => {
    const permissions = localStorage.getItem("permissions")?.split(",") || [];

    const hasPptPermission =
      permissions.includes(ROLE_DIGITAL_STORES) ||
      permissions.includes(ROLE_TAP_ADMIN);

    const isPptAdmin =
      permissions.includes(ROLE_TAP_ADMIN) ||
      permissions.includes(ROLE_ADMINISTRATOR);

    return { hasPptPermission, isPptAdmin };
  }, []); // Intentionally empty - localStorage is external, won't trigger re-computation
};
